import script from "./AllNewsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllNewsPage.vue?vue&type=script&setup=true&lang=js"

import "./AllNewsPage.vue?vue&type=style&index=0&id=57b06116&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b06116"]])

export default __exports__